import { Box, Tabs, Tab, Grid, Skeleton } from '@mui/material';
import { DataGrid, ptBR } from '@mui/x-data-grid';
import useTabsSimulacaoHook from '../../hooks/useTabsSimulacaoHook';
import './TabsSimulacao.scss';
import FiltrosTabela from '../FiltrosTabela/FiltrosTabela';
import SkeletonLoadingOverlay from '../SkeletonTabela/SkeletonTabela';

export default function TabsSimulacao({
  simularTaxas,
  buscarSimulacaoResumo,
  buscarAtualizarSimulacao
}) {
  const {
    tab,
    setTab,
    tabs,
    currentList,
    handleAction,
    SugestaoCard,
    SugestaoCardSkeleton,
    loading,
    loadingGrid,
    rows,
    columns,
    toolbarTabela,
    handleFiltrar,
    contadorFiltros,
    presetFiltros,
    handleRowSelectionModelChange,
    rowSelectionModelFiltered,
    paginationModel,
    handlePaginationModelChange,
    sortModel,
    rowCount,
    handleSortModelChange,
    loadingSelectionMap
  } = useTabsSimulacaoHook({ buscarSimulacaoResumo, buscarAtualizarSimulacao });

  const mostrarDataGrid = tabs[tab].key === 'porTitulo';
  const mostrarCards = tabs[tab].key !== 'porTitulo';

  return (
    <Box className="tabs-simulacao">
      <Box className="simu-tabs">
        <Tabs value={tab} onChange={(_, v) => setTab(v)} aria-label="Simulações">
          {tabs.map(t => (
            <Tab
              key={t.key}
              label={
                loading ? (
                  <Skeleton
                    className="skeleton-custom"
                    variant="rectangular"
                    animation="wave"
                    width="85%"
                    height={15}
                  />
                ) : (
                  t.label
                )
              }
            />
          ))}
        </Tabs>
      </Box>

      <Box className={`simu-grid-tiutlos ${mostrarDataGrid ? '' : 'hidden'}`}>
        <Box className="box-data-grid box-data-grid-lista-titulos">
          <FiltrosTabela
            onFiltrar={handleFiltrar}
            contadorFiltros={contadorFiltros}
            presetFiltros={presetFiltros}
          />
          <Grid container className="grid-titulos">
            <Grid className="content-datagrid-lista-titulos" item xs={12}>
              <DataGrid
                rows={rows}
                columns={columns}
                checkboxSelection
                loading={loadingGrid}
                className="data-grid-cessao data-grid-lista-titulos"
                pageSizeOptions={[10, 25, 50, 100]}
                disableRowSelectionOnClick
                rowSelectionModel={rowSelectionModelFiltered}
                onRowSelectionModelChange={handleRowSelectionModelChange}
                slots={{
                  toolbar: toolbarTabela,
                  loadingOverlay: SkeletonLoadingOverlay
                }}
                localeText={{
                  ...ptBR.components.MuiDataGrid.defaultProps.localeText
                }}
                paginationMode="server"
                paginationModel={paginationModel}
                onPaginationModelChange={handlePaginationModelChange}
                sortingMode="server"
                sortModel={sortModel}
                onSortModelChange={handleSortModelChange}
                rowCount={rowCount}
                getRowClassName={params => (loadingSelectionMap[String(params.id)] ? 'row-loading' : '')}
              />
            </Grid>
          </Grid>
        </Box>
      </Box>

      <Box className={`simu-grid ${mostrarCards ? '' : 'hidden'}`}>
        <Grid container spacing={3} columns={{ xs: 4, sm: 8, md: simularTaxas ? 20 : 12 }}>
          {loading &&
            Array.from({ length: simularTaxas ? 5 : 3 }, (_, i) => (
              <Grid key={`sk-${i}`} item xs={4} sm={4} md={4}>
                <SugestaoCardSkeleton />
              </Grid>
            ))}

          {!loading &&
            currentList.map(item => (
              <Grid key={item.id} item xs={4} sm={4} md={4}>
                <SugestaoCard item={item} onAction={handleAction} />
              </Grid>
            ))}

          {currentList.length === 0 && !loading && (
            <Grid item xs={12} sm={12} md={12}>
              <Box className="sem-dados">Nenhum título selecionado.</Box>
            </Grid>
          )}
        </Grid>
      </Box>
    </Box>
  );
}
